import { useRuntimeConfig } from '#imports'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

/**
 * Returns the Algolia index name for outlet scope based on environment and locale.
 * Format: {environment}_index_outlet_{locale}
 * Examples: preprod_index_outlet_fr-fr, prod_index_outlet_en-us
 */
export function useAlgoliaIndex() {
  const config = useRuntimeConfig()
  const locale = useI18nLocale()

  const environment = config.public.ENVIRONMENT === 'prod' ? 'prod' : 'preprod'
  const indexName = `${environment}_index_outlet_${locale}`

  return { indexName }
}
